/* (ignored) */


//////////////////
// WEBPACK FOOTER
// fs (ignored)
// module id = 4
// module chunks = 0 1